import Client from '@data/Client';

export default Client.resetStore;



// WEBPACK FOOTER //
// ./src/@data/Client/clearCache.js